module.exports = __webpack_public_path__ + "static/media/ii-la-controvertida.d15da400.pdf";